module.exports = __webpack_public_path__ + "static/media/coming-soon.adc6a353.png";